import { Info } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import {
  RatingSummary,
  ReviewCard,
  GoogleReviewsCTA,
} from "../components/Reviews";
import { reviews } from "../data/reviews";

export default function ReviewsPage() {
  return (
    <>
      <SEO
        title="Glow & Blow Reviews | Banjara Hills Salon"
        description="Read what clients say about Glow & Blow Unisex Salon in Banjara Hills, Hyderabad — Google rating and reviews."
      />
      <PageHero
        eyebrow="Reviews"
        titleLines={[
          <>Loved by Clients.</>,
          <>
            <em className="italic text-champagne">See What They Say.</em>
          </>,
        ]}
        copy="Genuine feedback matters to us. Our Google rating is shown below — review cards will display verified Google reviews once connected."
      />

      <section className="pb-24 md:pb-32" data-testid="reviews-page">
        <div className="container-x">
          <Reveal>
            <div className="flex flex-col items-start justify-between gap-10 border border-line bg-surface p-8 md:flex-row md:items-center md:p-14">
              <RatingSummary large />
              <div className="max-w-sm">
                <p className="text-sm leading-relaxed text-soften md:text-base">
                  Our rating comes from real client reviews on Google. Tap
                  below to read every review on our Google Business Profile.
                </p>
                <GoogleReviewsCTA className="mt-6" />
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div
              className="mt-10 flex items-start gap-3 border border-champagne/40 bg-champagne/10 p-4 text-sm text-taupe"
              data-testid="reviews-placeholder-note"
            >
              <Info className="mt-0.5 h-4 w-4 shrink-0 text-champagne-dark" />
              Review cards below are placeholders — verified Google reviews
              will appear here once live review data is connected. No review
              text on this page is fabricated.
            </div>
          </Reveal>

          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {reviews.map((r, i) => (
              <ReviewCard key={r.id} review={r} index={i} />
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
